// import { v4 as uuidv4 } from 'uuid';

import { institutionLoginsActions, institutionLoginsTypes } from 'app-components/flux/institution-logins';
import store from 'app-components/utils/redux-store';

import deterministicGuid from './deterministicGuid';
import { mergeMintImportSharedState } from './mintImportSharedState';

const importLogins = async (fileJS) => {
  const key = 'LOGINS';
  let simplifiLoginsByMintId;
  try {
    const mintLoginsById = fileJS.accounts.reduce((result, mintAccount) => {
      const fiLogin = result[mintAccount.fiLoginId] || {
        // clientId: uuidv4().toUpperCase(),
        clientId: deterministicGuid(mintAccount.fiLoginId),
        id: mintAccount.fiLoginId || '0',
        name: mintAccount.fiName,
      };
      return result.set(fiLogin.id, fiLogin);
    }, new Map());
    mintLoginsById.forEach((mintLogin) => {
      let uniqueLoginName = mintLogin.name;
      for (
        let index = 2;
        [...mintLoginsById.values()].find((login) => login.id !== mintLogin.id && login.name === uniqueLoginName);
        index += 1
      ) {
        // eslint-disable-line @typescript-eslint/no-loop-func
        uniqueLoginName = `${mintLogin.name}${index}`;
      }
      mintLogin.name = uniqueLoginName; // eslint-disable-line no-param-reassign
    });
    mergeMintImportSharedState({ key, progress: 20 });

    const loginsResponse = await new Promise((resolve, reject) => {
      store.dispatch(
        institutionLoginsActions.batchInstitutionLogins(
          [...mintLoginsById.values()].map((mintLogin) =>
            institutionLoginsTypes.mkInstitutionLoginClient({
              clientId: mintLogin.clientId,
              name: mintLogin.name,
            }),
          ),
          { resolve, reject },
        ),
      );
    });

    mergeMintImportSharedState({ key, progress: 80 });

    simplifiLoginsByMintId = loginsResponse.data.items.reduce((simplifiLogins, simplifiLogin) => {
      const mintLoginFound = [...mintLoginsById.values()].find(
        (mintLogin) => mintLogin.clientId === simplifiLogin.resource.clientId,
      );
      assert(mintLoginFound, 'mint login not found', { simplifiLogin });
      return mintLoginFound
        ? simplifiLogins.set(mintLoginFound.id, institutionLoginsTypes.mkInstitutionLoginClient(simplifiLogin.resource))
        : simplifiLogins;
    }, new Map());

    mergeMintImportSharedState({ key, progress: 100, [key]: { importedCount: simplifiLoginsByMintId.size } });
  } catch (error) {
    assert(false, error);
    mergeMintImportSharedState({ error: key, [key]: { error } });
  }

  return simplifiLoginsByMintId;
};

export default importLogins;
